import { ORDER_POSITION } from '@hive/status'

// Order meta statuses
export const ORDER_META_STATUS_PREPAYMENT_REFUNDED = ORDER_POSITION.REFUNDED_BEFORE_COMPLETE
export const ORDER_META_STATUS_REFUNDED = ORDER_POSITION.REFUNDED
export const ORDER_META_STATUS_WAITING_ASSEMBLER = ORDER_POSITION.WAITING_ASSEMBLER
export const ORDER_META_STATUS_ASSEMBLING = ORDER_POSITION.ASSEMBLING
export const ORDER_META_STATUS_NEED_CONTACT = ORDER_POSITION.NEED_CONTACT
export const ORDER_META_STATUS_REPLACED = ORDER_POSITION.REPLACED
export const ORDER_META_STATUS_REMOVED = ORDER_POSITION.REMOVED
export const ORDER_META_STATUS_ASSEMBLED = ORDER_POSITION.ASSEMBLED

export const ORDER_META_CANCELLED_REFUNDED_STATUSES = [
  ORDER_META_STATUS_REMOVED
]

export const ORDER_META_REFUNDED_STATUSES = [
  ORDER_META_STATUS_PREPAYMENT_REFUNDED,
  ORDER_META_STATUS_REFUNDED
]
